export default __webpack_public_path__ + "b4ec7d75304162becefc36260cce2482.png";